/* =============================================================================
   Legere Parts — visualização rápida
   Busca /products/{handle}?view=quick-view e injeta o HTML já renderizado pela
   Shopify, então preço, variantes e estoque nunca divergem da página real.
   ========================================================================== */
(function () {
  'use strict';

  const T = window.LegereTheme;
  const { trapFocus, releaseFocus, init, toast } = T.utils;

  function modal() {
    return document.querySelector('[data-quick-view]');
  }

  function open() {
    const el = modal();
    if (!el) return;
    el.hidden = false;
    void el.offsetWidth; // ver a nota sobre reflow em cart.js
    el.classList.add('is-open');
    trapFocus(el, close);
  }

  function close() {
    const el = modal();
    if (!el) return;
    el.classList.remove('is-open');
    releaseFocus();
    setTimeout(() => {
      el.hidden = true;
      const body = el.querySelector('[data-quick-view-content]');
      if (body) body.innerHTML = '';
    }, 200);
  }

  async function load(handle) {
    const el = modal();
    const body = el && el.querySelector('[data-quick-view-content]');
    if (!body) return;

    body.innerHTML = `<p class="modal__loading">${T.strings.loading || ''}</p>`;
    open();

    try {
      const res = await fetch(`${T.routes.root}products/${handle}?view=quick-view`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('[data-quick-view-product]');
      // outerHTML, não innerHTML: o próprio elemento (<div class="quick" ...>)
      // carrega a classe que vira o grid de 2 colunas — jogando fora o
      // wrapper e ficando só com o innerHTML, a imagem e as infos caíam
      // soltas uma embaixo da outra, sem grid nenhum aplicado. O <style> do
      // fragmento é irmão da div, não filho, então também nunca ia junto.
      const style = parsed.querySelector('style');
      body.innerHTML = (content ? content.outerHTML : html) + (style ? style.outerHTML : '');
      init(body);
    } catch (error) {
      close();
      toast(error.message, 'error');
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-view-open]');
    if (trigger) {
      event.preventDefault();
      load(trigger.dataset.quickViewOpen);
      return;
    }
    if (event.target.closest('[data-quick-view-close]')) {
      event.preventDefault();
      close();
    }
  });

  // Depois de adicionar pelo quick view, o modal sai da frente.
  document.addEventListener('cart:updated', () => {
    const el = modal();
    if (el && !el.hidden) close();
  });
})();
